import React, { useContext } from 'react';
import ImportSynchTripResultContext from './context';
import SynchTripResultImportSummary from './importSummary';
import { useSaveTripResults } from './hooks';

interface SynchTripResultImportDataProps {
  refetchCollectedCrystals: () => void;
}

const SynchTripResultImportData = (props: SynchTripResultImportDataProps) => {
  const { refetchCollectedCrystals } = props;
  const synchTripContext = useContext(ImportSynchTripResultContext);
  useSaveTripResults(refetchCollectedCrystals);

  return (
    <SynchTripResultImportSummary
      importedRows={synchTripContext.synchTripResultImportDTOList.length}
      validRows={
        synchTripContext.synchTripResultImportDTOList.filter((x) => !x.isDataInvalid)
          .length
      }
      inValidRows={
        synchTripContext.synchTripResultImportDTOList.filter((x) => x.isDataInvalid)
          .length
      }
    />
  );
};

export default SynchTripResultImportData;
